/**
 * @generated SignedSource<<25136a3bc772ab4f94a4a73c29965702>>
 * @relayHash d2cafaf913efd7a112daa29e9e08f227
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b0c1264cb29aba1af9d638f7bca6103bb482e694dafe1ad67c628fdcf34bd094

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraSoftwareIssueSearchCustomInputContext = "BACKLOG" | "BOARD" | "NONE" | "%future added value";
export type JiraIssueChangeInput = {
  issueId: string;
};
export type JiraIssueSearchInput = {
  childIssuesInput?: JiraIssueSearchChildIssuesInput | null | undefined;
  customInput?: JiraIssueSearchCustomInput | null | undefined;
  filterId?: string | null | undefined;
  jql?: string | null | undefined;
};
export type JiraIssueSearchChildIssuesInput = {
  filterByProjectKeys?: ReadonlyArray<string> | null | undefined;
  filterId?: string | null | undefined;
  jql?: string | null | undefined;
  namespace?: string | null | undefined;
  parentIssueKey: string;
  viewId?: string | null | undefined;
};
export type JiraIssueSearchCustomInput = {
  jiraSoftwareInput?: JiraSoftwareIssueSearchCustomInput | null | undefined;
};
export type JiraSoftwareIssueSearchCustomInput = {
  additionalJql?: string | null | undefined;
  context?: JiraSoftwareIssueSearchCustomInputContext | null | undefined;
  jiraEntityId: string;
};
export type JiraIssueSearchStaticViewInput = {
  isGroupingEnabled?: boolean | null | undefined;
  isHideDoneEnabled?: boolean | null | undefined;
  isHierarchyEnabled?: boolean | null | undefined;
};
export type groupsForIssues_realtimeUpdater_Query$variables = {
  cloudId: string;
  fieldId: string;
  firstNGroupsToSearch: number;
  issueChanges: ReadonlyArray<JiraIssueChangeInput>;
  issueSearchInput: JiraIssueSearchInput;
  staticViewInput: JiraIssueSearchStaticViewInput;
};
export type groupsForIssues_realtimeUpdater_Query$data = {
  readonly jira: {
    readonly groupsForIssues: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly __id: string;
          readonly afterGroupId: string | null | undefined;
          readonly id: string;
          readonly " $fragmentSpreads": FragmentRefs<"groupRow_issueTableGrouping_groupRow">;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type groupsForIssues_realtimeUpdater_Query = {
  response: groupsForIssues_realtimeUpdater_Query$data;
  variables: groupsForIssues_realtimeUpdater_Query$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyanyfieldstechnicalrelayprovider": isGroupByAnyFieldsTechnicalEnabled_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcgroupbyanyfieldstechnicalrelayprovider: {
    readonly get: () => boolean;
  };
});

import isGroupByAnyFieldsTechnicalEnabled_provider from '@atlassian/jira-relay-provider/src/group-by-any-fields-technical.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fieldId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "firstNGroupsToSearch"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueChanges"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueSearchInput"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "staticViewInput"
},
v6 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "fieldId",
    "variableName": "fieldId"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  },
  {
    "kind": "Variable",
    "name": "firstNGroupsToSearch",
    "variableName": "firstNGroupsToSearch"
  },
  {
    "kind": "Variable",
    "name": "issueChanges",
    "variableName": "issueChanges"
  },
  {
    "kind": "Variable",
    "name": "issueSearchInput",
    "variableName": "issueSearchInput"
  },
  {
    "kind": "Variable",
    "name": "staticViewInput",
    "variableName": "staticViewInput"
  }
],
v7 = {
  "kind": "ScalarField",
  "name": "id"
},
v8 = {
  "kind": "ScalarField",
  "name": "afterGroupId"
},
v9 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v10 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v11 = {
  "kind": "ScalarField",
  "name": "name"
},
v12 = {
  "concreteType": "JiraColor",
  "kind": "LinkedField",
  "name": "color",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "colorKey"
    },
    (v7/*: any*/)
  ]
},
v13 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v14 = {
  "kind": "ScalarField",
  "name": "statusCategoryId"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "name": "groupsForIssues_realtimeUpdater_Query",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v6/*: any*/),
            "concreteType": "JiraSpreadsheetGroupConnection",
            "kind": "LinkedField",
            "name": "groupsForIssues",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraSpreadsheetGroupEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraSpreadsheetGroup",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v8/*: any*/),
                      {
                        "kind": "FragmentSpread",
                        "name": "groupRow_issueTableGrouping_groupRow"
                      },
                      (v9/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v5/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyanyfieldstechnicalrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "groupsForIssues_realtimeUpdater_Query",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v6/*: any*/),
            "concreteType": "JiraSpreadsheetGroupConnection",
            "kind": "LinkedField",
            "name": "groupsForIssues",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraSpreadsheetGroupEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraSpreadsheetGroup",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v8/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "jql"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "fieldId"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "fieldType"
                      },
                      {
                        "kind": "LinkedField",
                        "name": "fieldValue",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/),
                          {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyanyfieldstechnicalrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "jqlTerm"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "concreteType": "JiraLabel",
                                    "kind": "LinkedField",
                                    "name": "label",
                                    "plural": false,
                                    "selections": [
                                      (v11/*: any*/),
                                      (v12/*: any*/)
                                    ]
                                  }
                                ],
                                "type": "JiraJqlLabelFieldValue"
                              }
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "JiraPriority",
                                "kind": "LinkedField",
                                "name": "priority",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "priorityId"
                                  },
                                  (v11/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "iconUrl"
                                  }
                                ]
                              },
                              (v13/*: any*/)
                            ],
                            "type": "JiraJqlPriorityFieldValue"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": [
                                  (v10/*: any*/),
                                  (v7/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "accountId"
                                  },
                                  (v11/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "picture"
                                  }
                                ]
                              },
                              (v13/*: any*/)
                            ],
                            "type": "JiraJqlUserFieldValue"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "JiraStatus",
                                "kind": "LinkedField",
                                "name": "status",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/),
                                  (v11/*: any*/),
                                  {
                                    "concreteType": "JiraStatusCategory",
                                    "kind": "LinkedField",
                                    "name": "statusCategory",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      (v14/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              (v13/*: any*/),
                              {
                                "concreteType": "JiraStatusCategory",
                                "kind": "LinkedField",
                                "name": "statusCategory",
                                "plural": false,
                                "selections": [
                                  (v14/*: any*/),
                                  (v7/*: any*/)
                                ]
                              }
                            ],
                            "type": "JiraJqlStatusFieldValue"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "number"
                              }
                            ],
                            "type": "JiraJqlNumberFieldValue"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "option",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "optionId"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "value"
                                  },
                                  (v12/*: any*/)
                                ]
                              },
                              (v13/*: any*/)
                            ],
                            "type": "JiraJqlOptionFieldValue"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "JiraSprint",
                                "kind": "LinkedField",
                                "name": "sprint",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "sprintId"
                                  },
                                  (v11/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "state"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "endDate"
                                  }
                                ]
                              },
                              (v13/*: any*/)
                            ],
                            "type": "JiraJqlSprintFieldValue"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "JiraGoal",
                                "kind": "LinkedField",
                                "name": "goal",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "status"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "score"
                                  }
                                ]
                              },
                              (v13/*: any*/)
                            ],
                            "type": "JiraJqlGoalsFieldValue"
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "issueCount"
                      },
                      (v9/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "b0c1264cb29aba1af9d638f7bca6103bb482e694dafe1ad67c628fdcf34bd094",
    "metadata": {},
    "name": "groupsForIssues_realtimeUpdater_Query",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyanyfieldstechnicalrelayprovider": isGroupByAnyFieldsTechnicalEnabled_provider
    }
  }
};
})();

(node as any).hash = "5b12b016130b4ac371febb9a4397fc68";

export default node;
